export default "__VITE_ASSET__SRZz6UIZ__"